'use client';

import { ReactNode, memo, CSSProperties } from 'react';

interface GradientTextProps {
  children: ReactNode;
  colors?: string[];
  animate?: boolean;
  className?: string;
  as?: 'span' | 'h1' | 'h2' | 'h3' | 'p';
}

/**
 * GradientText - Animated gradient text effect
 */
function GradientTextComponent({
  children,
  colors = ['#FF6B6B', '#FF8E72', '#00D4FF'],
  animate = true,
  className = '',
  as: Component = 'span',
}: GradientTextProps) {
  const gradientStyle: CSSProperties = {
    backgroundImage: `linear-gradient(135deg, ${colors.join(', ')})`,
    backgroundSize: animate ? '200% 200%' : '100% 100%',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: 'transparent',
    animation: animate ? 'gradient-shift 8s ease infinite' : 'none',
  };

  return (
    <>
      <style>{`
        @keyframes gradient-shift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        @media (prefers-reduced-motion: reduce) {
          .gradient-text-animated { animation: none !important; }
        }
      `}</style>
      <Component
        className={`gradient-text-animated ${className}`}
        style={gradientStyle}
      >
        {children}
      </Component>
    </>
  );
}

export const GradientText = memo(GradientTextComponent);
